<div class="ziro-admin-page-content">
  <div class="col-md-10 offset-md-1 pb-2">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item>
        <p class="mb-0" [innerHtml]="'tkey;reports.dashboard.description' | escapeHtml"></p>
      </ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>

    <div class="tile-container">
      <div class="row">
        <div class="col-md-6 col-lg-4 col-xl-3">
          <ziro-dashboard-orphaned-devices-tile></ziro-dashboard-orphaned-devices-tile>
        </div>
        <div class="col-md-6 col-lg-4 col-xl-3">
          <ziro-dashboard-unused-devices-tile></ziro-dashboard-unused-devices-tile>
        </div>
        <div class="col-md-6 col-lg-4 col-xl-3">
          <ziro-dashboard-license-optimizer-tile></ziro-dashboard-license-optimizer-tile>
        </div>
      </div>
    </div>
  </div>
</div>
